import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Modeles } from './pages/Modeles';
import { Configurateur } from './pages/Configurateur';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fbt3uywgof4t">
      <div className="flex min-h-screen w-full flex-col bg-cream font-sans" data-id="element-1" data-mp="3fb9if87lr8m1">
        <Header data-id="element-2" data-mp="2rlozgpbg8bcr" />
        <div className="flex-1" data-id="element-3" data-mp="2rl6vf6ijosua">
          <Routes data-id="element-4" data-mp="2mluboumz01vx">
            <Route path="/" element={<Home data-id="element-6" data-mp="2mn5b6i9dunh8" />} data-id="element-5" data-mp="2mmcb204xiw82" />
            <Route path="/modeles" element={<Modeles data-id="element-8" data-mp="31agmqk5ke7hc" />} data-id="element-7" data-mp="2mnnefyugq1yn" />
            <Route path="/personnaliser" element={<Configurateur data-id="element-10" data-mp="31c1igd3m7wgs" />} data-id="element-9" data-mp="31ayv2f5i4c5m" />
            <Route path="*" element={<Home data-id="element-12" data-mp="2wjqg73lejyl2" />} data-id="element-11" data-mp="2wka18t6cn33b" />
          </Routes>
        </div>
        <Footer data-id="element-13" data-mp="2wi5mthatqlos" />
      </div>
    </BrowserRouter>;
}